import { useSelector } from "react-redux";
import InvestmentContainer from "@/components/sections/TotalInvestments/InvestmentContainer";
import ErrorPage from "@/pages/ErrorPage.jsx";

export default function Dashboard() {

  const invError = useSelector((state) => state.investments.error);

  return (
    // tw-px-[36px] tw-py-8 tw-pt-[98px] sm:tw-px-[100px] sm:tw-pt-[118px]
    <div className="tw-p-0 sm:tw-p-6 tw-bg-[#FAFAFC]">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
        {
        invError?
          <ErrorPage errorTitle="Oops! Something went wrong.">{invError}</ErrorPage>
        :
          <InvestmentContainer />
        }
      </div>
    </div>
  );
}
